export var DefaultCacheExpirationTime = 1000 * 60 * 60 * 24; // 24 hours
export var DefaultCacheRefreshTimeout = 1000 * 60 * 60; // 1 hour
export var DefaultLockTimeout = 1000 * 10; // 10 sec
export var IndexDbCacheServiceName = "IndexDbCacheService";
export var ExpirationCacheServiceName = "IAsyncCacheService";
